/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EvaluationState = {
    WithoutEvaluation: 'WithoutEvaluation',
    Passed: 'Passed',
    Warning: 'Warning',
    Failed: 'Failed'
} as const;
export type EvaluationState = typeof EvaluationState[keyof typeof EvaluationState];


export function EvaluationStateFromJSON(json: any): EvaluationState {
    return EvaluationStateFromJSONTyped(json, false);
}

export function EvaluationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationState {
    return json as EvaluationState;
}

export function EvaluationStateToJSON(value?: EvaluationState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EvaluationState interface.
 */
 export function instanceOfEvaluationState(value: any): value is EvaluationState {
    return Object.values(EvaluationState).includes(value)
}

